import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const TemplateEditorLoader: LoadableType<
	Omit<
		{
			templateId?: string;
			spaceKey?: string;
		},
		'flags'
	>
> = LoadableAfterPaint({
	loader: async () => {
		const { TemplateEditor } = await import(
			/* webpackChunkName: "loadable-TemplateEditor" */ './TemplateEditor.tsx'
		);
		return TemplateEditor;
	},
});
